export default "__VITE_ASSET__BKsXWDDq__"